module.exports = __webpack_public_path__ + "static/media/generic-preview.9830b8e4.png";